import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import aboutWine from "@/assets/about-wine.svg";
import aboutFood from "@/assets/about-food.svg";
import aboutGuy from "@/assets/about-guy.svg";
import { LearnMoreLink } from "@/components/LearnMoreLink";

const SideImages = (): JSX.Element => (
  <div className="flex flex-col gap-24">
    <img
      src={aboutWine}
      alt="wine-pouring"
      className="w-[203px] ml-11 my-10 h-auto"
    />
    <img
      src={aboutFood}
      alt="food-ready-to-eat"
      className="w-[244px] h-auto ml-18"
    />
    <img
      src={aboutGuy}
      alt="guy-pouring-wine"
      className="w-[138px] h-auto -mt-16"
    />
  </div>
);

const Paragraphs = (): JSX.Element => (
  <div className="flex flex-col gap-4 gap-y-7 ml-30">
    <p className="text-2xl/8">
      DAILY AFFAIR was borne from a desire to slow down and keep things simple.
      Before lockdown, Melbourne had accelerated to such a pace that it often
      slipped our minds to take a breath and enjoy ourselves. At DAILY AFFAIR,
      our intention is to do just that.
    </p>
    <p className="text-lg/6 font-sans">
      We're not seeking to reinvent the wheel — fuss and frills are not what
      we're after, and we think others may feel the same. DAILY AFFAIR is all
      about neighbourly hospitality and honest dining. Victorian wines selected
      with careful consideration, plates celebrating locally farmed produce:
      these are the little pleasures that bring us immense joy, and we would
      like to share them with you, our community.
    </p>
    <p className="text-lg/6 font-sans">
      Richmond holds a special place in our hearts. Our founder Martin Pirc has
      called 3121 home for 35 years. You may remember some of our team from
      Saint.Urban or from around town at Punch Lane and Juliet Melbourne — we've
      been around the block and now we're back.
    </p>
    <p className="text-lg/6 font-sans">
      We see DAILY AFFAIR, our little haven on Richmond Hill, as a place to give
      back to our community the best way we know how: by giving you a place to
      meet, share stories and create memories.
    </p>
  </div>
);

const About = (): JSX.Element => {
  return (
    <>
      <div className="flex">
        <div className="w-1/3">
          <SideImages />
        </div>
        <div className="w-2/3">
          <Paragraphs />
        </div>
      </div>
      <LearnMoreLink
        className="font-frushand cursor-pointer text-xl mt-14"
        to="/learn-more"
      />
    </>
  );
};

export const Route = createFileRoute("/about")({
  component: About,
});
